import React from 'react';
import { fieldToTextField } from 'formik-material-ui';
import CustomTextField from '../Form/TextField';

const TextField = ({ children, helperText, FormHelperTextProps, error, ...props }) => {
  return (
    <CustomTextField
      {...fieldToTextField(props)}
      helperText={helperText}
      FormHelperTextProps={FormHelperTextProps}
      error={error}
    >
      {children}
    </CustomTextField>
  );
};

export default TextField;
